<template>
	<div>
		<CRow>
			<CCol sm="12">
				<CCard>
					<CCardHeader>
						Gestion des commandes

						<div class="card-header-actions">
							<router-link to="/orders/new">
								<CButton color="primary">Créer une commande</CButton>
							</router-link>
						</div>
					</CCardHeader>

					<CCardBody>
						<GDataTableRemote
							ref="mainTable"
							remote-url="/api/orders?concept=order.colikado"
							:fields="fields"
							:items-per-page="10"
							hover
							striped
							sorter
							columnFilter
							pagination>
							<template #contactChannel="{ item }">
								<td>
									{{ contactChannelTranslation[item.contactChannel] }}
								</td>
							</template>
							<template #status="{ item }">
								<td>
									<CBadge :color="statusColor[item.status]">{{
										statusTranslation[item.status]
									}}</CBadge>
								</td>
							</template>
							<template #actions="{ item }">
								<td class="text-center">
									<router-link :to="`/orders/${item.id}/edit`">
										<CIcon name="cil-pencil" />
									</router-link>
								</td>
							</template>
						</GDataTableRemote>
					</CCardBody>
				</CCard>
			</CCol>
		</CRow>
	</div>
</template>
<script>
	import GDataTableRemote from '../../../../components/ghostlexly-components/GDataTableRemote';

	export default {
		components: {
			GDataTableRemote,
		},

		data() {
			this.statusOptions = [
				{ value: 'order.pending', label: 'En attente de paiement' },
				{ value: 'order.awaiting_delayed_payment', label: 'En attente de paiement différé' },
				{ value: 'order.paid', label: 'Payée' },
				{ value: 'order.paused', label: 'En pause' },
				{ value: 'order.admin_authorized', label: 'Autorisation direction' },
				{ value: 'order.complete', label: 'Terminée' },
				{ value: 'order.payment_issue', label: 'Erreur de paiement' },
				{ value: 'order.canceled', label: 'Annulée' },
				{ value: 'order.refund', label: 'Remboursée' },
			];

			this.channelOptions = [
				{
					value: 'order.contact_channel.show_room',
					label: 'Show-room',
				},
				{
					value: 'order.contact_channel.web',
					label: 'Web',
				},
				{
					value: 'order.contact_channel.letter',
					label: 'Lettre',
				},
				{
					value: 'order.contact_channel.email',
					label: 'Email',
				},
				{
					value: 'order.contact_channel.phone',
					label: 'Téléphone',
				},
			];

			return {
				fields: [
					{ key: 'id', label: 'Identifiant unique' },
					{ key: 'createdAt', label: 'Créée le', type: 'daterange' },
					{
						key: 'status',
						label: 'Statut',
						type: 'select',
						filterSelectOptions: this.statusOptions,
					},
					{
						key: 'contactChannel',
						label: 'Prise de commande',
						type: 'select',
						filterSelectOptions: this.channelOptions,
					},
					{ key: 'owner.email', label: 'Email' },
					{ key: 'senderAddress.firstName', label: 'Prénom' },
					{ key: 'senderAddress.lastName', label: 'Nom' },
					{ key: 'senderAddress.postalCode', label: 'Code postal' },
					{ key: 'senderAddress.address', label: 'Adresse' },
					{ key: 'actions', filter: false },
				],
				statusTranslation: {
					'order.paused': 'En pause',
					'order.pending': 'En attente de paiement',
					'order.awaiting_delayed_payment': 'En attente de paiement différé',
					'order.paid': 'Payée',
					'order.admin_authorized': 'Autorisation direction',
					'order.complete': 'Terminée',
					'order.payment_issue': 'Erreur de paiement',
					'order.canceled': 'Annulée',
					'order.refund': 'Remboursée',
				},
				contactChannelTranslation: {
					'order.contact_channel.show_room': 'Show-room',
					'order.contact_channel.web': 'Web',
					'order.contact_channel.letter': 'Lettre',
					'order.contact_channel.email': 'Email',
					'order.contact_channel.phone': 'Téléphone',
				},
				statusColor: {
					'order.paused': 'warning',
					'order.pending': 'warning',
					'order.awaiting_delayed_payment': 'warning',
					'order.paid': 'success',
					'order.admin_authorized': 'success',
					'order.complete': 'success',
					'order.payment_issue': 'danger',
					'order.canceled': 'danger',
					'order.refund': 'warning',
				},
				customer: false,
			};
		},

		methods: {
			refresh: function () {
				this.$refs.mainTable.refresh();
			},
		},
	};
</script>
